import { useState } from "react";
import { updateSupport } from "../../../../../services/supports/supports";
import { showAlert } from "../../../../../main_components/alerts/alert_response";

interface UseTicketStatusProps {
  ticketData: any;
  onTicketUpdate?: (updatedTicket: any) => void;
  getCurrentTimestamp: () => string;
  notificationSystemRef: React.MutableRefObject<any>;
  setCurrentStatus: (status: string) => void;
}

export const useTicketStatus = ({
  ticketData,
  onTicketUpdate,
  getCurrentTimestamp,
  notificationSystemRef,
  setCurrentStatus,
}: UseTicketStatusProps) => {
  const [editingStatus, setEditingStatus] = useState(false);
  const [statusUpdating, setStatusUpdating] = useState(false);
  const [showReopenConfirm, setShowReopenConfirm] = useState(false);

  const confirmReopenTicket = async () => {
    setStatusUpdating(true);
    try {
      await updateSupport(ticketData.ticket, { status: "OPEN" });
      const updatedTimestamp = getCurrentTimestamp();

      onTicketUpdate?.({
        ...ticketData,
        status: "OPEN",
        last_update: updatedTimestamp,
      });

      setCurrentStatus("OPEN");

      showAlert({
        msj: "El ticket ha sido reabierto.",
        status: true,
        notificationSystemRef,
      });
    } catch (err: any) {
      showAlert({
        msj: err?.response?.data?.errorMessage || "Error al reabrir el ticket.",
        status: false,
        notificationSystemRef,
      });
    } finally {
      setStatusUpdating(false);
      setShowReopenConfirm(false);
    }
  };

  return {
    setCurrentStatus,
    editingStatus,
    setEditingStatus,
    statusUpdating,
    setStatusUpdating,
    showReopenConfirm,
    setShowReopenConfirm,
    confirmReopenTicket,
  };
};
